module.exports = __webpack_public_path__ + "static/media/fatherstephen_image1.79333e52.jpg";